<template>
	<md-toolbar
		md-elevation="0"
		class="md-transparent hide-for-print"
		:class="{scrolled: scrolled, 'bar-transparent': isOnLoginPage}"
	>
		<div class="md-toolbar-row">
			<div class="md-toolbar-section-start">
				<div class="background_warning_color" style="padding: 5px;" v-if="isLoggedIn && version.outdated">
					<i class="fa fa-warning" style="margin-right: 5px;"></i>
					<span v-html="newVersionInfoText"></span>
				</div>
			</div>
			<div class="md-toolbar-section-end">
				<div class="md-list-item-content">
					<i v-if="loginIcon"
					   class="fa inactive_color pointer font_lg secondary_color"
					   :class="loginIcon"
					   aria-hidden="true"
					   @click="logout"
					></i>
					<drop-down direction="down">
						<md-button
							slot="title"
							class="md-button md-just-icon md-simple"
							data-toggle="dropdown"
						>{{ activeLanguageType }}
						</md-button>
						<ul class="dropdown-menu dropdown-menu-right">
							<li v-for="(langProp, langKey) in enumDef.language.properties" @click="setLanguage(langKey)">
								<a href="javascript:;">{{$t(langProp.abbr)}}</a>
							</li>
							<li @click="setLanguage('KEY_zh')" style="display: none">
								<a href="javascript:;">KEY</a>
							</li>
						</ul>
					</drop-down>
					<SessionTimeoutCountdown v-if="isLoggedIn"></SessionTimeoutCountdown>
				</div>
				<div></div>
			</div>
		</div>
	</md-toolbar>
</template>

<script>
import SessionTimeoutCountdown from "@/views/Layout/SessionTimeoutCountdown";
import {mapGetters} from "vuex";
import {enumDef} from "@/common/enumDefs";

export default {
	components: {
		SessionTimeoutCountdown
	},
	data() {
		return {
			loginIcon: "",
			activeLanguageType: "",
			scrolled: false,
			enumDef: enumDef,
		};
	},
	created() {
		window.addEventListener("scroll", this.handleScroll);
	},
	destroyed() {
		window.removeEventListener("scroll", this.handleScroll);
	},
	mounted() {
		this.changeIcon();
		this.updateActiveLanguageType();
	},
	methods: {
		handleScroll() {
			this.scrolled = window.scrollY > 0;
		},
		changeIcon() {
			if (this.isLoggedIn) {
				this.loginIcon = "fa-sign-out";
			} else if (this.$route.meta.page === "register") {
				this.loginIcon = "fa-sign-in";
			} else {
				this.loginIcon = "";
			}
		},
		updateActiveLanguageType() {
			let ltype = this.getCookie("language") || enumDef.language.DE;
			this.activeLanguageType = this.$t(enumDef.language.properties[ltype].abbr);
		},
	},
	computed: {
		...mapGetters(["isLoggedIn", "version"]),
		newVersionInfoText() {
			return this.$t("news.newVersion", {
				linkStart: "<a href='javascript:;' onclick='window.location.reload()'>",
				linkEnd: "</a>"
			});
		},
		isOnLoginPage() {
			return this.$route.meta.page === "login";
		}
	},
	watch: {
		$route() {
			this.changeIcon();
			this.updateActiveLanguageType();
		}
	}
};
</script>
